import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { CicloFacturacion, EnumTipoCicloFacturacion } from '../../../oData'

export const apiFetchInvoiceCycles = async (
  invoiceCycleType: EnumTipoCicloFacturacion
): Promise<CicloFacturacion[]> => {
  return await AxiosInstance.get(
    `${getAppConfigurationValue(
      AppConfigurationKey.ApiUrlSuffixPioneer
    )}/api/InvoiceCycles/GetInvoiceCycles?invoiceCycleType=${invoiceCycleType}`
  ).then(response => {
    return response.data
  })
}
